import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import Hero from 'components/Hero';
import SecondaryEatery from 'components/SecondaryEatery';
import MainEatery from 'components/MainEatery';

const styles = theme => ({});

const Preview = props => {
  const { values } = props;
  const lastUpdated = new Date();
  const eateryData = {
    entity: {
      galleryImages: values.eateryImages.map(image => ({
        name: image.description,
        uri: image.uri || URL.createObjectURL(image.file),
        picCredits: image.picCredits,
      })),
      menuImages: values.menuImages.map(image => ({
        name: image.description,
        uri: image.uri || URL.createObjectURL(image.file),
      })),
      content: values.description,
      contactDetails: { phoneNumber: values.tel },
      eateryTimings: {
        openTimings: '',
      },
      amenities: values.amenities,
      ambience: values.ambiences,
      updatedAt: lastUpdated,
      openingHour: values.openingHour.map(
        ({ days, openingTime, closingTime }) =>
          `${days} ${openingTime}-${closingTime}`
      ),
    },
    curatorTips: values.tips.map(({ tip }) => ({
      tip,
      owner: { firstName: '', lastName: '', profilePic: null },
    })),
  };

  return (
    <Fragment>
      <Hero
        {...{
          title: values.name,
          lastUpdated: format(lastUpdated, 'MMM DD YYYY'),
          imageUrl:
            values.featuredImage.uri ||
            URL.createObjectURL(values.featuredImage.file),
          oneLiner: values.summary,
        }}
      />
      <SecondaryEatery
        {...{
          mustTryTags: values.mustTryDishes.map(({ label }) => label),
          alsoServesTags: values.alsoServes.map(({ label }) => label),
          cuisinesTags: values.cuisines.map(({ label }) => ({ name: label })),
          location: {
            locality: values.location.locality,
            latitude: values.location.latitude,
            longitude: values.location.longitude,
          },
          history: null,
        }}
      />
      <MainEatery {...{ eateryData, edit: true, prev: true }} />
    </Fragment>
  );
};

export default withStyles(styles)(Preview);
